var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_grid _grid-cols-1 _grid-cols-6--m _por-r _rounded--common",
    },
    [
      _c(
        "div",
        { staticClass: "_flex _jc-c _ai-c _col-span-1 _col-span-2--m _pos-r" },
        [
          _c("img", {
            staticClass: "_img-of-c gfu-embed__item",
            attrs: { src: _vm.projectImageUrl, alt: _vm.creator },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "_flexcol _jc-c _ai-c _gap-4 _tac _col-span-4--m _px-3--m _px-6--m",
        },
        [
          _c("div", [
            _vm._v("\n            " + _vm._s(_vm.content) + "\n        "),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm.creator
              ? _c("h4", { staticClass: "gfu-hd gfu-hd--h4" }, [
                  _vm._v(_vm._s(_vm.creator)),
                ])
              : _vm._e(),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$format(_vm.fundsGathered, "C0", "$")) +
                "+ raised\n        "
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }